import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { formatDate } from "../../utils";

const MarksTable = (props) => {
  return (
    <TableContainer component={Paper} style={{maxHeight:"400px"}}>
      <Table>
        <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
          <TableRow>
            {/* <TableCell>SUBJECT</TableCell> */}
            <TableCell>Date</TableCell>
            <TableCell>Marks</TableCell>
            <TableCell>Rank</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.data?.map((detail, index) => (
            <TableRow key={index}>
              <TableCell>{formatDate(new Date(detail.dateofExam))}</TableCell>
              <TableCell>
                {detail.marks === -1 ? "Absent" : `${detail.marks}/${detail.maxMarks}`}
              </TableCell>
              <TableCell>{detail.rank}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MarksTable;
